import React from 'react';
import { useAppSelector } from 'hooks';
import { selectSelectedProducts } from 'store/products';
import Table from 'layouts/Table';
import { ProductItem } from 'components/Campaign';
import { useFormContext } from 'react-hook-form';
import { Box, FormLabel, Flex, Spacer } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import { marketListPage } from 'components/Market';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { updateCampaignInfo, setAdded } from 'store/campaigns';
import { ButtonWithError } from 'components/Form.Buttons';
import { useTranslation } from 'react-i18next';

export const CampaignProducts = ({
  ...props
}: {
  [key: string]: any;
}): JSX.Element => {
  const { getValues } = useFormContext();

  const history = useHistory();
  const dispatch = useAppDispatch();
  const productList = useAppSelector(selectSelectedProducts);
  const { t } = useTranslation();

  function handleAddProducts() {
    dispatch(updateCampaignInfo(getValues()));
    dispatch(setAdded());
    history.push(marketListPage());
  }

  return (
    <Box {...props}>
      <Flex pb={5}>
        <FormLabel>
          {t('campaign.selectedProducts', 'Wybrane produkty')}
        </FormLabel>
        <Spacer />
        <ButtonWithError
          errorPath='products'
          onClick={handleAddProducts}
          variant='primary'
          size='sm'
          leftIcon={<FiPlus />}
        >
          {t('campaign.addProducts', 'Dodaj produkty')}
        </ButtonWithError>
      </Flex>

      <Table>
        <Table.Header>
          <Table.Column>{t('name_one', 'Nazwa')}</Table.Column>
          <Table.Column>{t('publisher_one', 'Wydawca')}</Table.Column>
          <Table.Column>{t('placement', 'Placement')}</Table.Column>
          <Table.Column>{t('model', 'Model')}</Table.Column>
          <Table.Column>{t('rate_one', 'Stawka')}</Table.Column>
          <Table.Column shrink>{t('actions', 'Akcje')}</Table.Column>
        </Table.Header>
        <Table.Body>
          {productList.map(product => (
            <ProductItem key={product.id} product={product} />
          ))}
        </Table.Body>
      </Table>
    </Box>
  );
};
